import styled from "styled-components";
import {
    CharcoalBlack,
    DarkSlate,
    ErrorRed,
    ErrorToolTip,
    GreyIce,
    LightSlate,
    Silver,
    Teal,
    White,
} from "../../../../theme/variable";
import {validateField} from "../../../../utils/validation";
import {media} from "../../../../theme/responsive";
import {CommonFieldStyled, CommonFieldLabel} from "../../CommonFieldStyled";

export const TextfieldDiv = styled(CommonFieldStyled)`
    margin-bottom: 3px;
    top: ${(props) => {
        if (validateField(props, "object", "textFieldStyle.mobile.top"))
            return props.textFieldStyle.mobile.top;
        return "-7px";
    }};
    ${media.laptop`
     top: ${(props) => {
         if (validateField(props, "object", "textFieldStyle.mobile.top"))
             return props.textFieldStyle.mobile.top;
         return "-7px";
     }};
`}
`;

export const TextfieldLabel = styled(CommonFieldLabel)`
    z-index: ${(props) => {
        if (props.disabled) {
            return "";
        } else {
            if (props.isError) return "";
            if (props.isFilled) return "";
            if (props.isFocused) return "1";
        }
        return "0";
    }};
    transform: ${(props) => {
        if (props.isFilled) {
            return `scale(0.8) translate3d(10px, 14px, 0)`;
        } else {
            if (props.isError && !props.disabled) return `scale(0.8) translate3d(10px, 14px, 0)`;
            if (props.isFocused) return `scale(0.8) translate3d(10px, 14px, 0)`;
        }
        return `scale(1) translate3d(0, 34px, 0);`;
    }};
    background: ${(props) => {
        if (props.disabled && props.isFilled) {
            return `${White}`;
        } else {
            if (props.isFocused) return `${White}`;
            if (props.disabled && (!props.isFilled || !props.isFocused)) return "transparent";
        }
        return `${White};`;
    }};

    padding: 0 8px;
    margin-left: ${(props) => {
        if ((props.isFocused || props.isFilled || props.isError) && !props.disabled) {
            return `0px`;
        } else if (props.disabled && props.isFilled) {
            return `0px`;
        }
        return `6px`;
    }};
    color: ${(props) => {
        if (props.disabled) {
            return `${LightSlate}`;
        } else {
            if (props.isFocused) return `${Teal}`;
            if (props.isError) return `${ErrorRed}`;
            if (props.isFilled) return `${CharcoalBlack}`;
        }
        return `${DarkSlate};`;
    }};
`;

export const Input = styled.input`
    z-index: ${(props) => {
        if (props.disabled) {
            return "";
        } else {
            if (props.isError) return "";
            if (props.isFilled) return "";
            if (props.isFocused) return "0";
        }
        return "1";
    }};
    border-radius: 0;
    display: flex;
    font-size: 0.9375rem;
    text-shadow: none;
    -webkit-appearance: none;
    order: 2;

    border-radius: 4px;
    padding: 15px 15px 13px 15px;
    width: 100%;
    background: ${(props) => {
        if (props.disabled && !props.isFilled) {
            return `${GreyIce}`;
        } else {
            if (props.isFilled || props.isFocused) return `${White}`;
        }
        return "transparent";
    }};
    color: ${(props) => {
        if (props.disabled) {
            return `${LightSlate}`;
        } else {
            if (props.isFilled || props.isFocused) return `${CharcoalBlack}`;
        }
        return `${CharcoalBlack};`;
    }};
    border: ${(props) => {
        if (props.disabled) {
            return `1px solid ${Silver}`;
        } else {
            if (props.isFocused) return `2px solid ${Teal}`;
            if (props.isError && !props.disabled) return `2px solid ${ErrorRed}`;
            if (props.isFilled) return `1px solid ${DarkSlate}`;
        }
        return `1px solid ${DarkSlate};`;
    }};
    &:focus {
        outline: 0;
    }
    &:focus + ${TextfieldLabel} {
        color: ${Teal};
        transform: scale(0.8) translate3d(10px, 14px, 0);
        background: ${White};
        text-align: center;
        align-items: center;
    }
    ${media.laptop` 
     height: ${(props) => {
         if (validateField(props, "object", "textFieldStyle.laptop.height"))
             return props.textFieldStyle.laptop.height;
         return "48px";
     }}; 
    line-height: ${(props) => {
        if (validateField(props, "object", "textFieldStyle.laptop.lineHeight"))
            return props.textFieldStyle.laptop.lineHeight;
        return "48px";
    }};     

    ::-webkit-inner-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }
    ::-webkit-outer-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }   
  `}
`;
export const ErrorHelperText = styled.div`
    background: ${ErrorToolTip};
    border-radius: 4px;
    padding: 10px;
    color: ${White};
    font-size: 0.8125rem;
    line-height: 1.38;
    width: ${(props) => (props.scoreWidth ? "160px" : "max-content")};
    max-width: ${(props) => (props.alignLeft ? "100%" : "220px")};
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.16);
    position: absolute;    
    left: ${(props) => {
        if (validateField(props, "object", "ErrorDivStyle.mobile.left"))
            return props.ErrorDivStyle.mobile.left;
        return "47%";
    }};
    // left:${(props) => (props.scoreWidth ? "20%" : "")};
    top: ${(props) => {
        if (validateField(props, "object", "ErrorDivStyle.mobile.top"))
            return props.ErrorDivStyle.mobile.top;
        return "75px";
    }};
    z-index: 2;
    transition: opacity 0.5s ease-in;
    transform: ${(props) => (props.alignLeft ? "" : "translateX(-50%)")};
    white-space: pre-line;
    &:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid ${ErrorToolTip};
        position: absolute;
        top: -7px;
        left: ${(props) => (props.alignLeft ? "6px" : "42%")};
    }
    ${media.laptop` 
        // left: ${(props) => (props.alignLeft ? "175px" : "50%")};
        left: ${(props) => {
            if (validateField(props, "object", "ErrorDivStyle.laptop.left"))
                return props.ErrorDivStyle.laptop.left;
            return "50%";
        }};
        top: ${(props) => {
            if (validateField(props, "object", "ErrorDivStyle.laptop.top"))
                return props.ErrorDivStyle.laptop.top;
            return "75px";
        }};
        max-width:  ${(props) => (props.alignLeft ? "350px" : "200px")};
        margin-top:0;
        transform:${(props) => (props.alignLeft ? "" : "translateX(-50%)")};
        min-width:max-content;
        `}
`;

export const TextInTextField = styled.span`
    position: absolute;
    top: 50%;
    right: 16px;
    cursor: pointer;
    color: ${DarkSlate};
    -webkit-tap-highlight-color: transparent;
`;
